import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Delegation from "./pages/Delegation";
import Error_404 from "./pages/Error_404";

function App() {
  return (
    <Routes>
      <Route path="/solicitation/:slug" element={<Delegation />} />
      <Route
        path="/solicitation/:slug/delegation/:uid"
        element={<Delegation />}
      />

      <Route path="*" element={<Error_404 />} />
    </Routes>
  );
}

function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default Root;
